// PROD-2959. What a patient tab shows while it has no organization (or practice) to write under.
//
// The personal-details, contact-details and demographics tabs used to fall back to a hard-coded
// DEV organization and practice id (`shared/api/dev-config.ts`, now deleted) whenever the auth
// context was empty. On any environment but DEV that put a real patient's create or save under an
// organization that is not the caller's. A tab now renders THIS instead of its form until the ids
// are known, so nothing can be submitted against a guessed organization.
import { Banner, Skeleton } from '@scripsteam/scrips-signal-ds';

export interface SessionOrgPendingProps {
  /**
   * True once the signed-in user is loaded. Before that the tab is waiting (a loading state);
   * after it, a missing id is a broken session, said plainly rather than shown as an endless load.
   */
  userLoaded: boolean;
}

export function SessionOrgPending({ userLoaded }: SessionOrgPendingProps) {
  if (userLoaded) {
    // The DS Banner (desk advisory on #621), not a hand-built paragraph.
    return (
      <Banner variant="warning" title="These details can't be shown" role="alert" data-testid="session-org-missing">
        Your sign-in has no organization or practice. Sign out and sign in again.
      </Banner>
    );
  }

  return (
    <div role="status" aria-label="Loading your organization" data-testid="session-org-loading" className="flex flex-col gap-3 py-6">
      <Skeleton className="h-5 w-48" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
}
